import Box from '@mui/material/Box';

export default function LargeLogo({ src }: { src: string }) {
  return <Box component="img" src={src} sx={{ width: 155.49, height: 36, cursor: 'pointer' }} />;
}
